export const requestStatusKeysConst = {
  PENDING: 1,
  ACCEPTED: 2,
  REJECTED: 3
};

export const packageStatus = {
  PUBLISH: 1,
  DRAFT: 2,
  SUSPENDED: 3
};
